import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { SizeProps } from '../avatar/avatar.styles';
import type { TextSize } from '../text/text-style-helpers';

export const SIZE_MAP: Record<
  SizeProps,
  { overlapSpacing: number; borderWidth: number; textSize: TextSize; textSpacing: number }
> = {
  xxs: { overlapSpacing: -0.5, borderWidth: 2, textSize: 'small', textSpacing: 0.5 },
  xs: { overlapSpacing: -1, borderWidth: 2, textSize: 'small', textSpacing: 0.75 },
  small: { overlapSpacing: -1.25, borderWidth: 3, textSize: 'medium', textSpacing: 1 },
  medium: { overlapSpacing: -1.5, borderWidth: 3, textSize: 'medium', textSpacing: 1.25 },
  large: { overlapSpacing: -2, borderWidth: 3, textSize: 'large', textSpacing: 1.5 },
  xl: { overlapSpacing: -2.5, borderWidth: 4, textSize: 'large', textSpacing: 1.5 },
  xxl: { overlapSpacing: -2.5, borderWidth: 4, textSize: 'large', textSpacing: 1.5 },
};

export const groupStyle = css`
  display: flex;
  align-items: center;
`;

export const avatarStyle = css`
  outline: var(--avatar-group-border-width) solid var(--avatar-group-border-color);
  border-radius: ${theme.borderRadius.full};
  margin-left: var(--avatar-group-overlap-spacing);
`;

export const firstAvatarStyle = css`
  outline: var(--avatar-group-border-width) solid var(--avatar-group-border-color);
  border-radius: ${theme.borderRadius.full};
`;

export const textStyle = css`
  margin-top: ${theme.spacing(0)};
  margin-right: ${theme.spacing(0)};
  margin-bottom: ${theme.spacing(0)};
  margin-left: var(--avatar-group-text-spacing);
  user-select: none;
`;

export const tooltipContentStyle = css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(1)};
  span {
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1)};
    p {
      margin: 0;
    }
  }
`;
